import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../config/config";
import { Container, Row, Col, Nav, Tab } from "react-bootstrap";
import Dashboardheader from "../directives/dashboardheader";
import {
  DepositWithdrwalHistory,
  walletStatisticsAction,
  adressUpdateAction,
  handleVestingWalletDataHistory,
  UserProfile,
  getNewCmsAction,
} from "../Action/user.action";
import toast, { Toaster } from "react-hot-toast";
import Cookies from "js-cookie";
import Passbook from "./Passbook/Passbook";
import { Switch } from "@mui/material";
import { FormControlLabel } from "@material-ui/core";
import Swal from "sweetalert2";
import Web3 from "web3";
import { useSelector } from "react-redux";
import WalletModal from "./Modals/walletSelectModal";
import ContentLoader from "react-content-loader";
import MigrationModal from "./Modals/MigrationWalletSelect";
import { MdOutlineStarPurple500 } from "react-icons/md";
import CancelWithdrawalRequest from "./Modals/CancelWithdrawalRequest";

const Wallethistory = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [migrationModalShow, setMigrationModalShow] = useState(false);

  const loginData = !Cookies.get("loginSuccessStepMrMint", {
    domain: "mrmint.io",
  })
    ? []
    : JSON.parse(
      Cookies.get("loginSuccessStepMrMint", { domain: "mrmint.io" })
    );
  const [wallethistorydata, setwallethistorydata] = useState({});
  const [activeTab, setActiveTab] = useState("withdrawrequest");
  const [viewbalance, setviewbalance] = useState(false);
  const [withdrawType, setWithdrawType] = useState(7);
  const [wallethistorydatalist, setwallethistorydatalist] = useState([]);
  const [StepcoinWallethistorydatalist, setStepcoinWallethistorydatalist] =
    useState([]);
  const [Businesswallethistorydatalist, setBusinesswallethistorydatalist] =
    useState([]);
  const [NftCoinwallethistorydatalist, setNftCoinwallethistorydatalist] =
    useState([]);

  const [refWallethistoryDatalist, setRefWallethistoryDatalist] = useState([]);
  const [vestingWalletHistoryDataList, setVestingWalletHistoryDataList] =
    useState([]);

  const [page, setPage] = useState(1);
  const stepWalletData = useSelector(
    (state) => state.Stepwallet.stepWalletData
  ); //this is for redux dont remove this line
  const [paginationStatus, setpaginationStatus] = useState(false);
  const [userData, setUserData] = useState(null);
  const [activeTabing, setActiveTabing] = useState(7);
  const [loding, setloding] = useState(false);
  const [showCancelRequestModal, setShowCancelRequestModal] = useState(false);
  const [cancelRequestData, setCancelRequestData] = useState({});

  // Handle view balance click
  const handleViewBalance = () => {
    setviewbalance(!viewbalance);
  };

  useEffect(() => {
    wallethistory();
    wallethistorylist();
    getUserProfile();
  }, [withdrawType, page]);

  const wallethistory = async () => {
    let res2 = await walletStatisticsAction();

    if (res2.success) {
      setwallethistorydata(res2.data);
    } else {
      setwallethistorydata([]);
    }
  };

  const wallethistorylist = async () => {
    setloding(true);
    try {
      let data = {
        page: page,
        limit: 10,
        withdraw_type: withdrawType,
      };
      console.log("data", data);
      let res = await DepositWithdrwalHistory(data);

      if (res.success) {
        setloding(false);
        if (res.data.history.length === 0) {
          setpaginationStatus(true);
        }
        if (withdrawType === 3) {
          setwallethistorydatalist((prevData) => [
            ...prevData,
            ...res.data.history,
          ]);
        }
        if (withdrawType === 5) {
          setStepcoinWallethistorydatalist((prevData) => [
            ...prevData,
            ...res.data.history,
          ]);
        }
        if (withdrawType === 6) {
          setBusinesswallethistorydatalist((prevData) => [
            ...prevData,
            ...res.data.history,
          ]);
        }
        if (withdrawType === 7) {
          setNftCoinwallethistorydatalist((prevData) => [
            ...prevData,
            ...res.data.history,
          ]);
        } else {
          setRefWallethistoryDatalist((prevData) => [
            ...prevData,
            ...res.data.history,
          ]);
        }
      } else {
        setloding(false);
        setwallethistorydatalist([]);
      }
    } catch (error) {
      setloding(false);
      console.log(error);
    }
  };

  // --------------------------------------------------------Email verification Modal code-----------------------------------------

  const handleEmailVerificationModal = async (e) => {
    // setshowModal(true);
    Swal.fire({
      title: `Email Verification Required`,
      html: "Please verify your email address to continue. <br/> <b>Important</b>: Once your email is verified, it cannot be changed later. <br/> Thank you for your cooperation!",
      confirmButtonColor: "#3085d6",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Verify!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        navigate(`${config.baseUrl}profile`);
      }
    });
  };
  const handleWalleteVerificationModal = async (e) => {
    // e.preventDefault();
    const result = await Swal.fire({
      title: "Final Wallet Address",
      html: "This can’t be changed later. Verify before saving.",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      customClass: {
        popup: "custum_background wallet_card", // multiple classes here
      },
    });
    if (!result.isConfirmed) {
      return;
    }
    connectMetasmaskForAddress();
  };

  const handleWithdrawlAction = (e) => {
    if (userData) {
      if (userData.is_email_verify === 0) {
        handleEmailVerificationModal(e);
        return;
      }

      if (!userData.bnb_address === null) {
        handleWalleteVerificationModal(e);
        return;
      }

      if (userData.country_name === null) {
        alert("Please select country first from mobile app!");
        return;
      }
      setShow(!show);
    }
  };
  const handleMigrationAction = (e) => {
    if (userData) {
      if (userData.is_email_verify === 0) {
        handleEmailVerificationModal(e);
        return;
      }

      if (!userData.bnb_address === null) {
        handleWalleteVerificationModal(e);
        return;
      }

      if (userData.country_name === null) {
        alert("Please select country first from mobile app!");
        return;
      }
      setMigrationModalShow(!migrationModalShow);
    }
  };

  const handleReferralWithdrawlAction = (e) => {
    navigate(`${config.baseUrl}referralwallet`);
  };

  const handelCreditBalanceHistoryAction = (e) => {
    navigate(`${config.baseUrl}CreditTransferHistory`);
  };

  const handleNFTCoinWallet = (e) => {
    navigate(`${config.baseUrl}nftcoinwwallet`);
  };
  const handleStakingAction = (e) => {
    navigate(`${config.baseUrl}staking`);
  };

  const handleWalletWithdrawl = (e) => {
    navigate(`${config.baseUrl}withdraw`);
  };

  const connectMetasmaskForAddress = async (e) => {
    try {
      if (window.ethereum) {
        var web3 = new Web3(window.ethereum);
        const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        let chainId = await web3.currentProvider.chainId;
        if (!chainId) {
          chainId = web3.currentProvider.getChainId();
        }
        if (
          chainId !== config.chainId &&
          web3.utils.toHex(parseInt(chainId)) !== config.chainId
        ) {
          toast.error(`Please select BNB smartchain!!`);

          return false;
        } else {
          if (accounts[0]) {
            let publicAddress = accounts[0];
            const { signature } = await new Promise((resolve, reject) =>
              web3.eth.personal.sign(
                web3.utils.fromUtf8(`Login Mrmint`),
                publicAddress,
                (err, signature) => {
                  if (err) return reject(err);
                  return resolve({ publicAddress, signature });
                }
              )
            );
            let res = await adressUpdateAction({
              bnb_address: accounts[0],
            });
            if (res.success) {
              loginData.bnb_address = accounts[0];
              Cookies.set("loginSuccessStepMrMint", JSON.stringify(loginData));
              window.location.href = `${config.baseUrl}wallethistory`;
              toast.success(res.msg);
            } else {
              toast.error(res.msg);
            }
          }
        }
      } else {
        toast.error("Please use Dapp browser!!");
      }
    } catch (error) {
      console.log("error", error);

      switch (error.code) {
        case 4001: // User rejected the request
          toast.error("User rejected the request.");
          break;
        case -32002: // Request already in progress
          toast.error(
            "Request already in progress. Please check your MetaMask wallet."
          );
          break;
        case "ERR_NETWORK": // Network issues
          toast.error("Network error. Please try again.");
          break;
        default:
          toast.error("An unexpected error occurred.");
          break;
      }
    }
  };

  // api for vesting wallet data ====================
  const handleVestingWalletData = async () => {
    setActiveTabing(1);
    setWithdrawType("");
    try {
      let data = {
        page: 1,
        limit: 10,
      };
      let res = await handleVestingWalletDataHistory(data);
      if (res.success) {
        setVestingWalletHistoryDataList(res.data.history);
      } else {
        setVestingWalletHistoryDataList([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getUserProfile = async () => {
    let res = await UserProfile();
    if (res.success) {
      setUserData(res.data);
    } else {
      setUserData([]);
    }
  };
  const handleLoadMore = () => {
    setPage(page + 1);
  };

  const handleTabChange = (id) => {
    
    if (activeTabing !== id) {
      setActiveTabing(id);
      setWithdrawType(id);
      setpaginationStatus(false);
      setPage(1);
      setloding(true);

      setwallethistorydatalist([]);
      setStepcoinWallethistorydatalist([]);
      setBusinesswallethistorydatalist([]);
      setNftCoinwallethistorydatalist([]);
      setRefWallethistoryDatalist([]);
      setVestingWalletHistoryDataList([]);
    }
  };

  const handleVestingWithdrawlAction = () => {
    navigate(`${config.baseUrl}vestingWallateHistory`);
  };
  // dynamic tabing  section data

  const handleCancelRequestButton = (data) => {

    let objectData = {
      id: data.id,
      withdraw_type: withdrawType,
      rejected_by: "USER",
    }
    setCancelRequestData(objectData);
    setShowCancelRequestModal(!showCancelRequestModal);

  }

  const ShimmerLoader = () => (
    <Row>
      {Array(3)
        .fill(0)
        .map((_, index) => (
          <Col xs={12} className="mb-3" key={index}>
            <ContentLoader
              speed={1.5}
              width="100%"
              height={80}
              viewBox="0 0 400 80" // Virtual coordinate system
              backgroundColor="#2a2a2a"
              foregroundColor="#3d3d3d"
              preserveAspectRatio="none" // This allows the rect to stretch fully
              style={{ width: "100%", height: "80px" }} // This is the real size
            >
              <rect x="0" y="0" rx="10" ry="10" width="400" height="80" />
            </ContentLoader>
          </Col>
        ))}
    </Row>
  );

  const TabContent = ({ eventKey, data, type }) => {
    return (
      <Tab.Pane eventKey={eventKey}>
        <Row className="gy-3 sofia-sans">
          {loding ? (
            <div className="text-center w-100 d-flex justify-content-center align-items-center">
              <ShimmerLoader />
            </div>
          ) : data.length > 0 ? (
            <>
              {data.map((item, index) => (
                <Col
                  xl={item.type === "vesting" ? 4 : 12}
                  lg={item.type === "vesting" ? 6 : 12}
                  key={index}
                >
                  <div
                    style={{
                      backgroundColor: "#151515",
                      borderRadius: 10,
                      textTransform: "capitalize",
                    }}
                  >
                    {/* 🔹 Card Header */}
                    <div
                      className="wallet-card-div text-secondary px-3 py-2 fs14"
                      style={{ borderRadius: "10px 10px 0px 0px" }}
                    >
                      {item.type === "vesting" ? (
                        <span className="text-white">Transfer</span>
                      ) : (
                        <span className="text-white"> Type : {item.type}</span>
                      )}
                    </div>

                    {/* 🔹 Vesting */}
                    {type === "vesting" && (
                      <Row className="gy-2 px-3 pt-3 sofia-sans">
                        <Col lg={4} md={4} sm={4} xs={4}>
                          <p className="text-secondary wcard-title mb-2">
                            Date
                          </p>
                          <p className="wcard-data">{item.transfer_date}</p>
                        </Col>
                        <Col
                          lg={4}
                          md={4}
                          sm={4}
                          xs={4}
                          className="text-center"
                        >
                          <p className="text-secondary wcard-title mb-2">
                            Amount
                          </p>
                          <p className="wcard-data">{item.amount}</p>
                        </Col>
                        <Col lg={4} md={4} sm={4} xs={4} className="text-end">
                          <p className="text-secondary wcard-title mb-2">
                            Status
                          </p>
                          <p className="text-success wcard-data">Success</p>
                        </Col>
                      </Row>
                    )}

                    {/* 🔹 Migration */}
                    {item.type === "Migration" && (
                      <Row className="gy-2 px-3 pt-3">
                        <Col className="text-center">
                          <p className="text-secondary wcard-title mb-2">
                            Migration Date
                          </p>
                          <p className="wcard-data">{item.requested_date}</p>
                        </Col>
                        <Col className="text-center">
                          <p className="text-secondary wcard-title mb-2">
                            Released Coin
                          </p>
                          <p className="wcard-data">{item.status}</p>
                        </Col>
                        <Col className="text-center">
                          <p className="text-secondary wcard-title mb-2">
                            Migration Amount
                          </p>
                          <p className="wcard-data fw-bold">
                            {item.usd_amount} Token
                          </p>
                        </Col>
                        <Col className="text-center d-flex flex-column align-items-center justify-content-start">
                          <p className="text-secondary wcard-title mb-2">
                            Transaction History
                          </p>
                          <button
                            className="btn btn-main2 px-4 py-0"
                            style={{ fontSize: 14, minHeight: 24 }}
                            onClick={() =>
                              navigate(
                                `${config.baseUrl}MigrationHistory?id=${item.id}`
                              )
                            }
                          >
                            View
                          </button>
                        </Col>
                      </Row>
                    )}

                    {/* 🔹 Other Types */}
                    {item.type !== "vesting" && item.type !== "Migration" && (
                      <Row className="gy-2 px-3 pt-3">
                        {!item.type?.includes("Airdrop") && (
                          <>
                            <Col className="text-center">
                              <p className="text-secondary wcard-title mb-2">
                                {item.type === "Credit Transfer"
                                  ? "Transfer Date"
                                  : item.type === "Adjustment"
                                    ? "Adjustment Date"
                                    : "Requested Date"}
                              </p>

                              <p className="wcard-data">
                                {item.type === "Credit Transfer"
                                  ? item.requested_date
                                  : item.requested_date || item.requestedDate}
                              </p>
                            </Col>

                            <Col className="text-center">
                              <p className="text-secondary wcard-title mb-2">
                                {item.type === "Credit Transfer"
                                  ? "Transfer Time"
                                  : item.type === "Adjustment"
                                    ? "Adjustment Time"
                                    : "Requested Time"}
                              </p>

                              <p className="wcard-data">
                                {item.type === "Credit Transfer"
                                  ? item.requested_time
                                  : item.requested_time || item.requestedTime}
                              </p>
                            </Col>
                          </>
                        )}

                        {item.type == 'Credit Transfer' ? "" :
                          <>
                            {
                              item.type !== "Adjustment" && (
                                <Col className="text-center">
                                  <p className="text-secondary wcard-title mb-2">
                                    {item.status === "Rejected"
                                      ? "Rejected Date"
                                      : item.status === "Cancelled" ? "Cancelled Date" : "Approved Date"}
                                  </p>
                                  <p className="wcard-data">{item.approved_date}</p>
                                </Col>
                              )
                            }
                            {item.type !== "Adjustment" && (
                              <Col className="text-center">
                                <p className="text-secondary wcard-title mb-2">
                                  {item.status === "Rejected"
                                    ? "Rejected Time"
                                    : item.status === "Cancelled" ? "Cancelled Time" : "Approved Time"}
                                </p>
                                <p className="wcard-data">{item.approved_time}</p>
                              </Col>
                            )}
                          </>
                        }
                        <Col className="text-center">
                          <p className="text-secondary wcard-title mb-2">
                            Amount
                          </p>
                          <p
                            style={{ fontWeight: 700 }}
                            className={` ${item.status === "Pending" 
                              ? "text-warning"
                              : item.status === "Rejected" ||
                                item.type === "Adjustment" || item.status === "Cancelled"
                                ? "text-danger"
                                : "text-success"
                              } wcard-data`}
                          >
                            {item.usd_amount || item.amount} {item.coinname}
                          </p>
                        </Col>

                        <Col className="text-center">
                          <p className="text-secondary wcard-title mb-2">
                            {item.type === "Credit Transfer"
                              ? "Wallet Address"
                              : item.trx_hash
                                ? "Transaction Hash"
                                : "Status"}
                          </p>
                          <p
                            className={`${item.status === "Pending"
                              ? "text-warning"
                              : item.status === "Rejected" || item.status === "Cancelled"
                                ? "text-danger"
                                : "text-success"
                              } wcard-data d-flex justify-content-center align-items-center gap-2`}
                            style={{ flexWrap: "wrap" }}
                          >
                            {item.trx_hash ? (
                              <>
                                <a
                                  href={`https://anantascan.io/tx/${item.trx_hash}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-white"
                                  style={{ textDecoration: "none" }}
                                >
                                  {`${item.trx_hash.slice(
                                    0,
                                    4
                                  )}...${item.trx_hash.slice(-4)}`}
                                </a>
                                <button
                                  onClick={() => {
                                    navigator.clipboard.writeText(
                                      item.trx_hash
                                    );
                                    toast.success(
                                      "Transaction hash copied to clipboard!"
                                    );
                                  }}
                                  className="btn btn-sm btn-outline-success py-0 px-2"
                                  style={{
                                    fontSize: "0.75rem",
                                    borderRadius: "6px",
                                  }}
                                >
                                  Copy
                                </button>
                              </>
                            ) : (
                              item.status
                            )}
                          </p>
                        </Col>

                        {/* Action for cancel request */}
                        { item.status === 'Pending' && <Col className="text-center">
                         <div className="w-btn-list justify-content-between gap-2 flex-wrap">
                          <div>
                            <button
                              type="button"
                              className="w-btn card-view w-100"
                              onClick={() => handleCancelRequestButton(item)}
                            >
                              <div style={{ position: "relative" }}>
                             
                                <small>Cancel Request </small>
                              </div>
                            </button>
                          </div>
                        </div>
                        </Col>}

                      </Row>
                    )}
                  </div>
                </Col>
              ))}
            </>
          ) : (
            // ✅ NO DATA
            <div
              className="text-center d-flex justify-content-center align-items-center flex-column"
              style={{
                padding: "20px",
                color: "#d3d3d3",
                borderRadius: "8px",
              }}
            >
              <img
                style={{ width: "auto", height: "auto" }}
                src="assets/images/newdesign/nodata-new.png"
                width={120}
                className="mb-4"
                alt="No Data"
              />
              <h4 className="text-white">No data found</h4>
            </div>
          )}
        </Row>
      </Tab.Pane>
    );
  };

  return (
    <>
      <Dashboardheader />
      <Toaster />
      <div className="position-relative">
        <div className="db1"></div>
        {/* <div className="db2"></div> */}
        {/* <div className="db3"></div> */}
        <div className="db4"></div>
        <div className="db5"></div>
        <div className="db6"></div>
        <div className="db7"></div>
        <div className="db8"></div>

        <div className="shape_bg">
          <img src="assets/images/shape2.svg" className="shape2" alt="" />
        </div>
        <div className="page-wrapper">
          <div className="position-relative overflow-hidden mt-5 pt-2 mb-5">
            <div className="mb-4">
              <Container className="">
                <Row className="align-items-center">
                  <Col lg={9}>
                    <h2
                      className="text-white sofia-sans"
                      style={{ fontWeight: 600 }}
                    >
                      Wallet Overview
                    </h2>
                  </Col>
                </Row>
              </Container>
            </div>
            {/* ---------- */}

            <div className="">
              <Container>
                <Row>
                  <Col lg={5} md={12} className="mb-3">
                    <div className="wallet_card">
                      <div className="card-view3 p-4">
                        <div className="d-flex justify-content-between align-items-center">
                          <h4 className="text-light-grey mb-3 sofia-sans">
                            Total Balance
                          </h4>

                          <div
                            className="mb-3"
                            onClick={(e) => e.stopPropagation()} // Stop clicks from bubbling
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={viewbalance}
                                  onChange={(e) => {
                                    e.stopPropagation(); // Make sure switch change doesn't bubble
                                    handleViewBalance(e);
                                  }}
                                />
                              }
                              label={
                                <span style={{ fontSize: 10, color: "white" }}>
                                  {viewbalance ? "Hide" : "Show"}
                                </span>
                              }
                              style={{ color: "white" }}
                            />
                          </div>
                        </div>
                        <div>
                          <h4>
                            <img
                              src="assets/images/AnnantaWhite.png"
                              width="18px"
                              alt="MNT"
                              className="me-2"
                            />
                            &nbsp;
                            {viewbalance
                              ? wallethistorydata.total_balance_anannta > 0
                                ? wallethistorydata.total_balance_anannta
                                : 0
                              : "********"}{" "}
                            <span style={{ fontSize: 10 }}>ANANT</span>
                          </h4>
                        </div>
                        <div>
                          {wallethistorydata.total_balance_mnt > 0 && (
                            <h4>
                              <img
                                src="assets/images/mntcoin.png"
                                width="20px"
                                className="me-2"
                                alt="MNT"
                              />
                              &nbsp;
                              {viewbalance
                                ? wallethistorydata.total_balance_mnt
                                : "********"}{" "}
                              <span style={{ fontSize: 10 }}>MNT</span>
                            </h4>
                          )}

                        </div>

                        {/* Action Button */}
                        <div className="w-btn-list justify-content-between gap-2 flex-wrap mt-4 h-100">
                          <div>
                            <button
                              type="button"
                              className="w-btn card-view w-100"
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent bubbling
                                handleWithdrawlAction();
                              }}
                            >
                              <div style={{ position: "relative" }}>
                                <img
                                  src="assets/images/wallet02.png"
                                  alt=""
                                  style={{ width: 35, height: 35 }}
                                />
                                &nbsp;&nbsp;<small>Wallets</small>
                              </div>
                            </button>
                          </div>

                          {(userData?.step_balance != 0 ||
                            userData?.referral_wallet_balance != 0) && (
                              <div>
                                <button
                                  type="button"
                                  className="w-btn card-view w-100"
                                  onClick={(e) => {
                                    e.stopPropagation(); // Prevent bubbling
                                    handleMigrationAction();
                                  }}
                                >
                                  <div style={{ position: "relative" }}>
                                    <img
                                      src="assets/images/wallet02.png"
                                      alt=""
                                      style={{ width: 35, height: 35 }}
                                    />
                                    &nbsp;&nbsp;<small>Migrate </small>
                                  </div>
                                </button>
                              </div>
                            )}
                        </div>

                        <div className="chart_icon" style={{ zIndex: -1 }}>
                          <img src="assets/images/chart_wave.png" alt="" />
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col lg={1} className="mb-3" />
                  <Col lg={5} md={12} className="mb-3">
                    <div className="wallet_card">
                      <div className="card-view3 p-4">
                        <div className="d-flex justify-content-between align-items-center">
                          <h4 className="text-light-grey mb-3 sofia-sans">
                            Credit Balance{" "}
                            <div>
                              <h2 className="text-white mb-0 mt-3">
                                {" "}
                                {wallethistorydata.credit_balance}
                              </h2>
                            </div>
                          </h4>
                        </div>
                        <div
                          style={{
                            backgroundColor: "#EFC9010D",
                            color: "#EFC901",
                            border: "1px solid #EFC901",
                            borderRadius: 5,
                          }}
                          className="px-3 py-1"
                        >
                          <span className="mb-0 align-items-center d-flex gap-1">
                            {" "}
                            <MdOutlineStarPurple500 /> You can only use this
                            balance to buy NFT Box{" "}
                          </span>
                        </div>

                        {/* Action Button */}
                        <div className="w-btn-list justify-content-between gap-2 flex-wrap mt-4 ">
                          <div>
                            <button
                              type="button"
                              className="w-btn card-view w-100"
                              onClick={handelCreditBalanceHistoryAction}
                            >
                              <div style={{ position: "relative" }}>
                                {/* <img
                                src="assets/images/wallet02.png"
                                alt=""
                                style={{ width: 35, height: 35 }}
                              /> */}
                                <small>View History </small>
                              </div>
                            </button>
                          </div>
                        </div>

                        <div className="chart_icon" style={{ zIndex: -1 }}>
                          <img src="assets/images/chart_wave.png" alt="" />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Col
                  lg={12}
                  style={{
                    fontSize: "14px",
                    marginTop: "2.5px",
                    whiteSpace: "normal",
                  }}
                  className="mt-3"
                >

                  {/* <p>{wallethistorydata.termsCondition}</p>  */}
                  <p
                    className="mb-0 sofia-sans"
                    style={{ fontSize: 14 }}
                    dangerouslySetInnerHTML={{
                      __html: wallethistorydata.termsCondition,
                    }}
                  />
                </Col>
              </Container>
            </div>

            {/* ---------- */}

            <div className="transaction mb-5">
              <Container>
                <h2
                  className="text-white mb-4 sofia-sans"
                  style={{ fontWeight: 600 }}
                >
                  Statistics
                </h2>
                <div className="transaction_detail">
                  <Row className="sofia-sans ">
                    <Col lg={3} sm={6} className="mb-4 d-flex ">
                      <div className="listbox flex-fill d-flex align-items-center justify-content-center w-100 ">
                        <div className="d-flex flex-column gap-2">
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.step_earning_anant}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.stepReward}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p className="mb-0 text-center fs14 sofia-sans">
                            Step Rewards
                          </p>
                        </div>
                      </div>

                    </Col>
                    <Col lg={3} sm={6} className="mb-4 d-flex  ">
                      <div className="listbox flex-fill d-flex align-items-center justify-content-center w-100 ">
                        <div className="d-flex flex-column gap-2">
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.referral_earning_anant}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.referralAmount}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p className="mb-0 text-center fs14 sofia-sans">
                            Referral Rewards
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col lg={3} sm={6} className="mb-4 d-flex ">
                      <div className="listbox flex-fill d-flex align-items-center justify-content-center w-100 ">
                        <div className="d-flex flex-column gap-2">
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.matching_earning_anant }
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.matchingAmount}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p className="mb-0 text-center fs14 sofia-sans">
                            Community Rewards
                          </p>
                        </div>
                      </div>
                    </Col>

                    <Col lg={3} sm={6} className="mb-4 d-flex  r">
                      <div className="listbox flex-fill d-flex align-items-center justify-content-center w-100 ">
                        <div className="d-flex flex-column gap-2">
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.loyalty_earning}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p className="mb-0 text-center fs14 sofia-sans">
                            Walker Loyalty Rewards
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col lg={3} sm={6} className="mb-4 d-flex  r">
                      <div className="listbox flex-fill ">
                        <div className="d-flex flex-column gap-2">
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.withdraw_anant}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                           <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.withdraw_mnt}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p className="mb-0 text-center fs14 sofia-sans">
                            Total Withdrawn
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col lg={3} sm={6} className="mb-4 d-flex ">
                      <div className="listbox flex-fill d-flex align-items-center justify-content-center w-100 ">
                        <div className="d-flex flex-column gap-2">
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.migration_request}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p className="mb-0 text-center fs14 sofia-sans">
                            Migration Token
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col lg={3} sm={6} className="mb-4 d-flex ">
                      <div className="listbox flex-fill d-flex align-items-center justify-content-center w-100 ">
                        <div className="d-flex flex-column gap-2">
                          <p
                            style={{ fontWeight: 700, fontSize: 20 }}
                            className="text-white text-center mb-0"
                          >
                            {wallethistorydata.migration_amount}
                            {/* <small style={{ fontSize: 10 }}>MNT</small> */}
                          </p>
                          <p className="mb-0 text-center fs14 sofia-sans">
                            Released Coin
                          </p>
                        </div>
                      </div>
                    </Col>
                    
                  </Row>
                </div>
              </Container>
            </div>

            {/* ---------- */}
            <div className="latest_transaction mb-5">
              <Container>
                <Tab.Container
                  id="left-tabs-example"
                  defaultActiveKey="nftCoinWallet"
                  onSelect={(key) => setActiveTab(key)}
                >
                  <h2
                    className="text-white mb-4 sofia-sans"
                    style={{ fontWeight: 600 }}
                  >
                    Wallet History
                  </h2>
                  <Nav variant="pills" className=" text-center ">
                    <Row className="w-100 text-center mb-4">
                      <Col lg={2} sm={6}>
                        <Nav.Item>
                          <Nav.Link
                            onClick={() => handleTabChange(7)}
                            eventKey="nftCoinWallet"
                            className="card-view1 customnav-link px-0"
                          >
                            Step Legacy Wallet
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                      <Col lg={2} sm={6}>
                        <Nav.Item>
                          <Nav.Link
                            onClick={() => handleTabChange(5)}
                            eventKey="stepCoinWallet"
                            className="card-view1 customnav-link px-0"
                          >
                            NFT Box Wallet
                          </Nav.Link>
                        </Nav.Item>
                      </Col>

                      <Col lg={2} sm={6}>
                        <Nav.Item>
                          <Nav.Link
                            onClick={() => handleTabChange(6)}
                            eventKey="businessCoinWallet"
                            className="card-view1 customnav-link px-0"
                          >
                            Business Coin Wallet
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                      <Col lg={2} sm={6}>
                        <Nav.Item>
                          <Nav.Link
                            onClick={() => handleTabChange(3)}
                            eventKey="stepwallet"
                            className="card-view1 customnav-link px-0"
                          >
                            StepMint Wallet
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                      <Col lg={2} sm={6}>
                        <Nav.Item>
                          <Nav.Link
                            onClick={() => handleTabChange(4)}
                            eventKey="referralwallet"
                            className="card-view1 customnav-link px-0"
                          >
                            Business Wallet
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                      <Col lg={2} sm={6}>
                        <Nav.Item>
                          <Nav.Link
                            onClick={handleVestingWalletData}
                            eventKey="vestingwallet"
                            className="card-view1 customnav-link px-0"
                          >
                            Vesting Wallet
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                    </Row>
                  </Nav>
                  <Tab.Content>
                    <TabContent
                      eventKey="nftCoinWallet"
                      data={NftCoinwallethistorydatalist}
                    />
                    <TabContent
                      eventKey="stepCoinWallet"
                      data={StepcoinWallethistorydatalist}
                    />
                    <TabContent
                      eventKey="businessCoinWallet"
                      data={Businesswallethistorydatalist}
                    />
                    <TabContent
                      eventKey="stepwallet"
                      data={wallethistorydatalist}
                    />
                    <TabContent
                      eventKey="referralwallet"
                      data={refWallethistoryDatalist}
                    />
                    <TabContent
                      eventKey="vestingwallet"
                      data={vestingWalletHistoryDataList}
                      type="vesting"
                    />
                  </Tab.Content>
                </Tab.Container>
              </Container>
            </div>

            {activeTabing === 3 &&
              wallethistorydatalist.length >= 10 &&
              !loding && (
                <>
                  {!paginationStatus && (
                    <center onClick={handleLoadMore}>
                      <div
                        className="gap-2 py-3 joined-user"
                        style={{
                          color: "white",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "black",
                          width: 180,
                          borderRadius: 8,
                        }}
                      >
                        <div className="ani-container">
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                        </div>
                        <div style={{ fontWeight: 500 }}>Load More</div>
                      </div>
                    </center>
                  )}
                </>
              )}
            {activeTabing === 4 &&
              refWallethistoryDatalist.length >= 10 &&
              !loding && (
                <>
                  {!paginationStatus && (
                    <center onClick={handleLoadMore}>
                      <div
                        className="gap-2 py-3 joined-user"
                        style={{
                          color: "white",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "black",
                          width: 180,
                          borderRadius: 8,
                        }}
                      >
                        <div className="ani-container">
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                        </div>
                        <div style={{ fontWeight: 500 }}>Load More</div>
                      </div>
                    </center>
                  )}
                </>
              )}
            {activeTabing === 5 &&
              StepcoinWallethistorydatalist.length >= 10 &&
              !loding && (
                <>
                  {!paginationStatus && (
                    <center onClick={handleLoadMore}>
                      <div
                        className="gap-2 py-3 joined-user"
                        style={{
                          color: "white",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "black",
                          width: 180,
                          borderRadius: 8,
                        }}
                      >
                        <div className="ani-container">
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                        </div>
                        <div style={{ fontWeight: 500 }}>Load More</div>
                      </div>
                    </center>
                  )}
                </>
              )}
            {activeTabing === 6 &&
              Businesswallethistorydatalist.length >= 10 &&
              !loding && (
                <>
                  {!paginationStatus && (
                    <center onClick={handleLoadMore}>
                      <div
                        className="gap-2 py-3 joined-user"
                        style={{
                          color: "white",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "black",
                          width: 180,
                          borderRadius: 8,
                        }}
                      >
                        <div className="ani-container">
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                        </div>
                        <div style={{ fontWeight: 500 }}>Load More</div>
                      </div>
                    </center>
                  )}
                </>
              )}
            {activeTabing === 7 &&
              NftCoinwallethistorydatalist.length >= 10 &&
              !loding && (
                <>
                  {!paginationStatus && (
                    <center onClick={handleLoadMore}>
                      <div
                        className="gap-2 py-3 joined-user"
                        style={{
                          color: "white",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "black",
                          width: 180,
                          borderRadius: 8,
                        }}
                      >
                        <div className="ani-container">
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                        </div>
                        <div style={{ fontWeight: 500 }}>Load More</div>
                      </div>
                    </center>
                  )}
                </>
              )}
            {activeTabing === 1 &&
              vestingWalletHistoryDataList.length >= 10 &&
              !loding && (
                <>
                  {!paginationStatus && (
                    <center onClick={handleLoadMore}>
                      <div
                        className="gap-2 py-3 joined-user"
                        style={{
                          color: "white",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "black",
                          width: 180,
                          borderRadius: 8,
                        }}
                      >
                        <div className="ani-container">
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                          <div className="chevron"></div>
                        </div>
                        <div style={{ fontWeight: 500 }}>Load More</div>
                      </div>
                    </center>
                  )}
                </>
              )}
          </div>
        </div>
        {show && (
          <WalletModal
            show={show}
            handleClose={() => setShow(!show)}
            userData={userData}
            handleWalletWithdrawl={handleWalletWithdrawl}
            handleVestingWithdrawlAction={handleVestingWithdrawlAction}
            handleReferralWithdrawlAction={handleReferralWithdrawlAction}
            handleNFTCoinWallet={handleNFTCoinWallet}
            handleStakingAction={handleStakingAction}
            wallethistorydata={wallethistorydata}
          />
        )}
        {migrationModalShow && (
          <MigrationModal
            show={migrationModalShow}
            handleClose={() => setMigrationModalShow(!migrationModalShow)}
            userData={userData}
            handleWalletWithdrawl={handleWalletWithdrawl}
            handleVestingWithdrawlAction={handleVestingWithdrawlAction}
            handleReferralWithdrawlAction={handleReferralWithdrawlAction}
            handleStakingAction={handleStakingAction}
            wallethistorydata={wallethistorydata}
          />
        )}

        {
          showCancelRequestModal && <CancelWithdrawalRequest
            showCancelRequestModal={showCancelRequestModal}
            handleClose={() => setShowCancelRequestModal(!showCancelRequestModal)}
            data={cancelRequestData}
          />
        }
      </div>
    </>
  );
};
export default Wallethistory;
